module.exports = __webpack_public_path__ + "static/media/Banner_Desktop.2bec4ec5.jpg";